import { useEffect, useState, useRef } from "react";
import { InputGroup } from "react-bootstrap";
import { AutoComplete } from "components";
import { UsuarioManager } from "managers";
import ToolTip from "components/ToolTip/ToolTip";
import { GridView } from "components/GridView/GridView";
import IconButton from "components/IconButton/IconButton";
import useExceptionHandler from "hooks/useExceptionHandler";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import {
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal,
} from "..";
import "../Lookup.style.scss";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import Select from "react-select";
import { Usuario } from "models/usuario";
import { Simplebar } from "components/Simplebar/Simplebar";
import { SvgComponent } from "components/SvgComponent/SvgComponent";
import { DEFAULT_PAGINATION_VALUES } from "utils";

export const UsuarioLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  placeHolder = "Usuario",
  isDisabled,
  isInput = false,
  equipoIdSec,
}) => {
  const ref = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [usuarioListModal, setUsuarioListModal] = useState([]);
  const [selectedValue, setSelectedValue] = useState({ label: "", value: "" });
  const [whereModal, setWhereModal] = useState(initialWhereModal);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const ESTATUS_LIST = [{ value: "", label: "Todos" }, ...Usuario.ESTATUS_LIST];

  useEffect(() => {
    if (whereModal != initialWhereModal) {
      buscar();
    }
  }, [whereModal, equipoIdSec]);

  useEffect(() => {
    if (
      selectedValue != undefined &&
      selectedValue.value !== null &&
      selectedValue.value != ""
    ) {
      onChange(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (
      initialValue.value &&
      initialValue.value != "" &&
      initialValue.value !== selectedValue.value &&
      initialValue.value !== -1
    ) {
      setValue();
    }
    if (initialValue.value === -1) {
      setSelectedValue({ label: "", value: "" });
    }
  }, [initialValue.value]);

  const setValue = () => {
    UsuarioManager.buscarPorId(initialValue.value, true).then((data) =>
      setSelectedValue(data)
    );
  };

  function buscar() {
    const whereWithPaginationValues = {
      ...whereModal,
      ...pagination,
      EquipoIdSec: equipoIdSec,
    };
    UsuarioManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setUsuarioListModal(res.Data);
      })
      .catch((err) => handleException(err));
  }

  const handleCerrar = () => {
    setShowCanvas(false);
    setWhereModal(initialWhereModal);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const res = await UsuarioManager.listado({
      ...initialWhere,
      EquipoIdSec: equipoIdSec,
      Descripcion: inputValue,
    });
    return res.Data;
  };

  return (
    <>
      {!isInput ? (
        <InputGroup className="w-100">
          <div style={{ width: controlsProportion.input }}>
            <AutoComplete
              placeholder="Usuarios"
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={setSelectedValue}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
            />
          </div>
          <InputGroup.Append style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              message="Seleccionar Usuario"
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </InputGroup.Append>
        </InputGroup>
      ) : (
        <>
          <div style={{ width: controlsProportion.inputGroup }}>
            <AutoComplete
              placeholder="Usuarios"
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={setSelectedValue}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
            />
          </div>
          <InputGroup.Append style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              message="Seleccionar Usuario"
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </InputGroup.Append>
        </>
      )}
      {showCanvas && (
        <Simplebar
          backdrop={true}
          ref={ref}
          placement={"end"}
          portal={false}
          size="lg"
          useLoading={true}
          visible={showCanvas}
          setShow={(e) => {
            setShowCanvas(e);
          }}
          title="Seleccionar Usuario"
          btnLeft={{
            show: false,
            func: () => {},
          }}
          btnRight={{
            show: false,
            func: () => {},
          }}
        >
          <GridView
            pagination={pagination}
            setPagination={setPagination}
            allowPaging={pagination.EsPaginable}
            pageSize={pagination.CantidadPorPagina}
            pageIndex={pagination.IndiceDePagina}
            lastPageNumber={pagination.PaginasTotal}
            dataSource={usuarioListModal}
            onPageIndexChanging={onPageIndexChanging}
            where={whereModal}
            setWhere={setWhereModal}
          >
            <GridView.Column
              bodyRenderer={(row) => {
                return (
                  <div className="float-right">
                    <IconButton
                      onClick={() => {
                        setSelectedValue({
                          label: row.Descripcion,
                          value: row.IdSec,
                        });
                        handleCerrar();
                      }}
                    >
                      <ToolTip message="Seleccionar">
                        <div>
                          <SvgComponent
                            height="20"
                            width="20"
                            iconName="check"
                          />
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div>
                );
              }}
            />
            <GridView.Column
              width="250px"
              headerText="Nombre"
              dataField="Descripcion"
              sortExpression="Descripcion"
            />
            <GridView.Column
              width="250px"
              headerText="Correo Electrónico"
              dataField="Email"
              sortExpression="Email"
            />
            <GridView.Column
              width="200px"
              headerText="Estatus"
              dataField="Estatus"
              sortExpression="Estatus"
              filterRenderer={() => {
                return (
                  <Select
                    className="react-select primary"
                    options={ESTATUS_LIST}
                    value={ESTATUS_LIST.filter(function (option) {
                      return (
                        option.value ===
                        (whereModal.Estatus
                          ? whereModal.Estatus
                          : ESTATUS_LIST[0].value)
                      );
                    })}
                    name="Estatus"
                    onChange={(e) =>
                      setWhereModal({
                        ...whereModal,
                        Estatus: e.value,
                      })
                    }
                  />
                );
              }}
            />
          </GridView>
        </Simplebar>
      )}
    </>
  );
};
